import React from "react";
import ResidentialCheckList from "./ResidentialCheckList";
// import "./Residential_dropdown.css";


function ResidentialCheckBox()
{

    return(

        // <div className="dropdown">
        //   <button className="btn dropdown-toggle" type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
        //     All Residentials</button>
              
              <div className="dropdown-menu"  aria-labelledby="dropdownMenuButton2">
              <ResidentialCheckList/>
              <ResidentialCheckList/>
              <ResidentialCheckList/>
              <ResidentialCheckList/>
              <ResidentialCheckList/>
              <ResidentialCheckList/>
              <ResidentialCheckList/>
                  {/* <div className="mb-3 form-check">
                       <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                       <label className="dropdown-label" for="flexCheckDefault">
                       Default checkbox</label>
                 </div>
                 <div className="mb-3 form-check">
                       <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                       <label className="dropdown-label" for="flexCheckDefault">
                       Default checkbox</label>
                 </div>
                 <div className="mb-3 form-check">
                       <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                       <label className="dropdown-label" for="flexCheckDefault">
                       Default checkbox</label>
                 </div>
                 <div className="mb-3 form-check">
                       <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                       <label className="dropdown-label" for="flexCheckDefault">
                       Default checkbox</label>
                 </div>
                 <div className="mb-3 form-check">
                       <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                       <label className="dropdown-label" for="flexCheckDefault">
                       Default checkbox</label>
                 </div>
                 <div className="mb-3 form-check">
                       <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                       <label className="dropdown-label" for="flexCheckDefault">
                       Default checkbox</label>
                 </div>
                 <div className="mb-3 form-check">
                       <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                       <label className="dropdown-label" for="flexCheckDefault">
                       Default checkbox</label>
                 </div>
                 <div className="mb-3 form-check">
                       <input className="form-check-input" type="checkbox" value="" id="flexCheckDefault"/>
                       <label className="dropdown-label" for="flexCheckDefault">
                       Default checkbox</label>
                 </div> */}
                 
             </div>
              

    );
}

export default ResidentialCheckBox;